// src/icon-system/runtime/IkonKoprusu.tsx — ESKİ ↔ MOTOR köprüsü (Faz C; motor kolu TEMBEL)
//
// Codemod (`tooling/gecis.js --dalga N --kopru`) eski ikon çağrısını SİLMEZ, bu köprünün
// `eski` prop'una taşır; motor kolu ARTIK BİLEŞEN DEĞİL, AİLE KİMLİĞİdir:
//   <IkonKoprusu aile="navigation.home" varyant="selected" eski={<AiFillHome />} />
//   <IkonKoprusu aile="navigation.discovery" eski="✨" />
//
// ── NİYE AİLE KİMLİĞİ, NİYE `yeni={<XIkon/>}` DEĞİL (ölçüldü 2026-09-07) ──
// `yeni={<NavigationHomeIkon/>}` yazmak, çağıran ürün dosyasına `generated/NavigationHome`
// import'u koyar; o dosya eager olduğu için kullanılan aileler İLK PAKETE girer. Ölçülen
// bedel: dalga 1 +2 631 B, dalga 2 +2 603 B gzip → 390 910 B / tavan 393 390 (kalan
// 2 480 B; dalga 3'ün 83 adayı bu yapıyla tavanı aşardı). Bayrak VARSAYILAN KAPALI
// olduğu için bu bayt, motoru HİÇ görmeyen kullanıcının ödediği bayttı. Aile kimliği bir
// DİZGEDİR: modül bağı kurmaz; bileşen, bayrak açıkken tek `ikon-motor` chunk'ından
// (`runtime/motorYukleyici`) çözülür.
//
// ── DAVRANIŞ ─────────────────────────────────────────────────────────────
//   bayrak KAPALI            → `eski` olduğu gibi (piksel-birebir; eski import CANLI
//                              kalır, `kullanilmayan` cırcırına düşmez) · chunk İSTENMEZ
//   bayrak AÇIK, chunk hazır → motor (ilk render'da; `motorModulu()` senkron)
//   bayrak AÇIK, chunk yolda → `eski` (AYNI KUTU) → chunk gelince BİR kez motora geçer
//   aile bilinmiyor / chunk hatası → `eski` (güvenli yön; sessiz boşluk yok, warn 1 kez)
//
// Bayrak tespiti RENDER'DAN ÖNCE SENKRONdur (`ikonMotoruAcikMi()` → localStorage), yani
// açık kolda boş/atlayan bir kare YOKTUR: geçiş "eski → motor"dur, "boşluk → motor"
// değil (aynı kutu → CLS 0; GÖZ perf-metrics ölçer). Bayrak kalkınca köprü codemod'la
// sökülür: aile kimliği doğrudan bileşene döner, `eski` + eski import gider.
import React from "react";
import { ikonMotoruAcikMi } from "./ikonBayragi";
import { konturPropu, motorBileseni, useMotorModulu } from "./motorYukleyici";
import { motorYayinaUygun } from "./yayinKapisi";
import type { IkonBoyut } from "./IconFrame";
import type { MotorAileAdi } from "./motorSozlesmesi";

/** Generated families plus explicitly registered language-specific additions. */
export type IkonAilesi = MotorAileAdi;

export type IkonKoprusuProps = Omit<React.SVGProps<SVGSVGElement>, "children" | "ref" | "title"> & {
  /** Motor ailesi (`navigation.home`). Dizge — modül bağı KURMAZ (tembel chunk'tan çözülür). */
  aile: IkonAilesi;
  /** Bayrak kapalıyken (ve chunk gelene kadar) çizilen: eski bileşen ya da emoji metni. */
  eski: React.ReactNode;
  /** Motor varyantı; varsayılan "outline". */
  varyant?: "outline" | "selected";
  /** Boyut kademesi (token). Token dışı px `style` + `data-boyut-px` ile taşınır. */
  boyut?: IkonBoyut;
  /** Verilirse ikon dekoratif DEĞİL (IconFrame: role=img + aria-label + <title>). */
  title?: string;
  /**
   * Metin akışı kipi (KULLANIM_SOZLESMESI §4) — `IconFrame satirIci`ye aynen
   * geçer: `inline-block` + `--ikon-metin-hiza` + kutu `--ikon-kullanim-metin`.
   * Bayrak KAPALI kolda `eski` çizilir, bu prop HİÇ okunmaz (delta 0).
   */
  satirIci?: boolean;
  /** Kutu ölçüsünün ADLI kanalı — `IconFrame kutuOlcu`ya aynen geçer
   *  (`"var(--ikon-kullanim-aksiyon)"`, `"1em"` …). Bayrak KAPALI kolda
   *  `eski` çizilir, bu prop HİÇ okunmaz. */
  kutuOlcu?: string;
  /** Token dışı px kutusu (borç `data-boyut-px` ile görünür kalır). */
  kutuPx?: number;
};

let uyarilanAile: Set<string> | null = null;

export function IkonKoprusu({ aile, eski, ...motorProps }: IkonKoprusuProps): React.ReactElement {
  const acik = ikonMotoruAcikMi(); // SENKRON (localStorage) — render'dan ÖNCE bilinir
  const modul = useMotorModulu(acik);
  if (!acik || !modul) return <>{eski}</>;
  // ── YAYIN KAPISI (2026-09-26) — aile + varyant, tek boğazda ───────────
  // Bayrak tek boole olduğu için taslak aileler (IkonTaslak çerçevesi) onaylı
  // ailelerle BİRLİKTE açılıyordu; owner çerçeveyi ürünün parçası saymadığından
  // bayrak kimseye açılamıyor, onaylı 77 aile üç taslağı bekliyordu (#1102).
  // #1100 aynı kapıyı varyant düzeyine indirdi (`composer.sticker.selected`
  // görsel kabul bekliyor). İki karar `yayinKapisi.motorYayinaUygun`ta TEKTİR:
  //   `onayli` (varsayılan) → taslak aile / bekleyen varyant `eski`yi çizer
  //                           (bayrak kapalı koluyla DOM-birebir)
  //   `tam`                 → önizleme (IkonTaslak çerçevesi + bekleyen varyant)
  //   metadata eksik        → her kapsamda `eski` (eski chunk onay sayılmaz)
  // `?ikonAday` burada OKUNMAZ: o yalnız `OzellikIkonu`nda aday aileye geçer
  // ve aday aile taslak olduğu için bu kapıdan geçemez.
  // Bu satır köprüde durur, çünkü köprü 300+ çağrı yerinin tek boğazıdır
  // (`OzellikIkonu` da buradan geçer). Adaptörler `cozumleyici` üzerinden aynı
  // fonksiyonu sorar; `motorBileseni` de kendi içinde sorar (ikinci mandal).
  // Bilinmeyen aile (`aileAdiCoz` null) aşağıdaki `!Bilesen` dalına düşer ki
  // "motorda yok" uyarısı sessizce yutulmasın.
  if (modul.aileAdiCoz(aile) && !motorYayinaUygun(modul, aile, motorProps.varyant)) return <>{eski}</>;
  const Bilesen = motorBileseni(modul, aile, motorProps.varyant);
  if (!Bilesen) {
    // Aile derlenmişte yok (JS çağıran / bayat kimlik): ESKİ çizilir — boş kutu DEĞİL.
    uyarilanAile ||= new Set<string>();
    if (!uyarilanAile.has(aile)) {
      uyarilanAile.add(aile);
      // eslint-disable-next-line no-console
      console.warn(`[ikon] köprü ailesi motorda yok: ${aile} → eski ikon çizildi (sessiz boşluk değil).`);
    }
    return <>{eski}</>;
  }
  return <Bilesen {...konturPropu(modul)} {...(motorProps as Record<string, unknown>)} />;
}
